import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/(dashboard)/company-certificates/_components/certificates-grid.tsx");
